import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'

export const encrypt = (message, secret) =>
  AES.encrypt(JSON.stringify(message), secret).toString()

export const decrypt = (encrypted, secret) =>
  JSON.parse(AES.decrypt(encrypted, secret).toString(Utf8))

